import Link from 'next/link';
import React from 'react';

import { IResolvedFooterNavItem } from '@/src/utils/collections/footer.mapper';

type IFooterGridLinks = {
  title: string | null;
  items: IResolvedFooterNavItem[];
};

export const FooterGridLinks = ({ title, items }: IFooterGridLinks) => {
  return (
    <div className={'space-y-4'}>
      <h5 className={'font-semibold text-white'}>{title}</h5>
      <div className="grid grid-flow-col grid-rows-6 gap-4">
        {items.map(item => (
          <Link
            key={item.url}
            href={item.url}
            className="text-neutral-300 no-underline"
            onClick={() => {
              window.dataLayer?.push({
                event: 'click_button',
                click_id: item.url,
                click_label: item.name,
              });
              window.scroll({ top: 0, behavior: 'smooth' });
            }}
          >
            {item.name}
          </Link>
        ))}
      </div>
    </div>
  );
};
